<template>
  <v-autocomplete
      v-model="stock_part"
      :items="$store.state.stock_parts.search"
      :label="$filters.capitalize($t('stock_parts.label'))"
      :item-props="stockPartProps"
      v-model:search="autocompleteSearchStockPart"
      :loading="$store.state.stock_parts.isSearching"
      append-icon="mdi-text-box-search"
      return-object
      :clearable="true"
      variant="solo"
      >
      <template #no-data>
        {{
        $filters.capitalize(
        $t("search_for", { noun: $t("stock_parts.label", 1) })
        )
        }}
      </template>
  </v-autocomplete>
</template>

<script>
  import { stockPartProps } from "@/mixins/props.js";
  import utils from "@/mixins/utils.js";
  
  const { delayedSearch } = utils.methods;


  export default {
    props: {
      onlyUnits: { type: Boolean, required: false, default: false }
    },
    methods: {
      updateStockPart(val) {
        if (val) {
          var payload = { value: val, size: 50 };
          if (this.onlyUnits) payload["unity"]='un';
          this.delayedSearch(val, "stock_parts/searchItems", payload);
        }
      },
      stockPartProps,
      delayedSearch: delayedSearch,
    },
    watch: {
      autocompleteSearchStockPart(val) {
        if (!this.$store.getters.canSearch("stock_parts")) return;
        if (val != this.stock_part){  
          this.updateStockPart(val);
        }
      },
      stock_part(val) {
        this.$store.dispatch('units/updateEdit', {...this.$store.state.units.edit, stock_part: val})

      },
    },
    data() {
      return {
        autocompleteSearchStockPart: null,
        stock_part: undefined,
      }
    },
  }
</script>
